import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaSignInAlt, FaEye, FaEyeSlash } from "react-icons/fa";
import { Turnstile } from "@marsidev/react-turnstile";
import logo from "../assets/logo.png";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [empresaSigla, setEmpresaSigla] = useState("VRI");
  const [turnstileToken, setTurnstileToken] = useState("");
  const navigate = useNavigate();

  // Verificacao Cloudflare Turnstile: exibida quando a chave do site estiver
  // configurada (homologacao/producao). No desenvolvimento local fica oculta.
  const turnstileSiteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

  const handleLogin = async (e) => {
    e.preventDefault();

    if (turnstileSiteKey && !turnstileToken) {
      alert("Confirme a verificação de segurança antes de acessar.");
      return;
    }

    try {
      const API_URL = process.env.REACT_APP_API_URL || "/api";
      const response = await axios.post(`${API_URL}/login`, {
        email,
        senha,
        empresa_sigla: empresaSigla,
        turnstileToken,
      });

      console.log("Resposta login:", response.data);

      // 1️⃣ Verifica se veio token
      if (!response?.data?.token) {
        alert("Erro: o backend não retornou token!");
        return;
      }

      // 2️⃣ Salva token
      const token = response.data.token;
      localStorage.setItem("token", token);

      // 3️⃣ Monta e salva dados do usuário
      const usuario = response.data?.usuario ?? {
        id: response.data?.id,
        nome: response.data?.nome,
        email: response.data?.email,
        tipo: response.data?.tipo,
        empresa_id: response.data?.empresa_id,
        empresa_nome: response.data?.empresa_nome,
        empresa_sigla: response.data?.empresa_sigla,
      };

      if (usuario?.tipo) {
        const tipoNormalizado = usuario.tipo
          .toString()
          .trim()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        console.log("🔥 Tipo salvo:", usuario.tipo, "→", tipoNormalizado);

        localStorage.setItem("tipoUsuario", tipoNormalizado);
      } else {
        console.warn("⚠ Não veio 'tipo' no retorno. Salvando visitante.");
        localStorage.setItem("tipoUsuario", "visitante");
      }

      localStorage.setItem("usuario", JSON.stringify(usuario));

      localStorage.setItem("empresa_id", response.data.empresa_id);
      localStorage.setItem("empresa_nome", response.data.empresa_nome);
      localStorage.setItem("empresa_sigla", response.data.empresa_sigla);

      // 4️⃣ Redireciona
      navigate("/home");
    } catch (err) {
      console.error("Erro no login:", err);

      if (err.response?.data?.erro) {
        alert(err.response.data.erro);
      } else if (err.code === "ERR_NETWORK") {
        alert("Erro: não foi possível conectar ao servidor!");
      } else {
        alert("Erro inesperado ao autenticar.");
      }
    }
  };

  return (
    <div className="login-container">
      <img src={logo} alt="Logo Grupo Serbom" className="logo-topo" />

      <div className="login-box">
        <h2 className="login-titulo">Login</h2>

        <form onSubmit={handleLogin}>
          <select id="empresa" value={empresaSigla} onChange={(e) => setEmpresaSigla(e.target.value)} required className="campo">
            <option value="VRI">VRI</option>
            <option value="VSA">VSA</option>
          </select>

          <input
            type="email"
            id="email"
            placeholder="Usuário"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="campo"
            autoComplete="username"
          />

          <div className="campo-senha">
            <input
              id="senha"
              type={mostrarSenha ? "text" : "password"}
              placeholder="Digite sua Senha"
              required
              className="campo"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              autoComplete="current-password"
            />

            <span className="toggle-senha" onClick={() => setMostrarSenha(!mostrarSenha)}>
              {mostrarSenha ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {turnstileSiteKey && (
            <div style={{ margin: "12px 0" }}>
              <Turnstile
                siteKey={turnstileSiteKey}
                onSuccess={(token) => setTurnstileToken(token)}
                onExpire={() => setTurnstileToken("")}
                onError={() => setTurnstileToken("")}
                options={{
                  theme: "dark",
                  size: "normal",
                }}
              />
            </div>
          )}

          <button type="submit" className="btn-acessar">
            <FaSignInAlt className="icon" /> Acessar
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
